// extracted by mini-css-extract-plugin
module.exports = {"helpIcon":"Label_helpIcon__3sARy","label":"Label_label__3X-bA","tooltip":"Label_tooltip__3lW43","help":"Label_help__35AwI"};